import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import translate from 'core/translate'
import { isHorizontalMenu } from 'core/helpers/menu'
import { cn } from 'ethcss'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import { InstancesCatalogExhibitions } from './exhibitions'
import { InstancesCatalogExhibitionsPages } from './exhibitionsPages'
import styles from './instancesCatalog_exhibition.jcss'
import {
    EXHIBITION_MODULE_KEY,
    EXHIBITION_TABS,
    EXHIBITION_TITLE_KEY,
    ExhibitionTab,
} from './InstancesCatalogExhibition-types'

const InstancesCatalogExhibitionComponent = () => {
    const [activeTab, setActiveTab] = useState<ExhibitionTab>('exhibitionsList')

    const renderActiveTab = () => {
        switch (activeTab) {
            case 'exhibitionsList':
                return <InstancesCatalogExhibitions />
            case 'exhibitionsPagesList':
                return <InstancesCatalogExhibitionsPages />
            default:
                return null
        }
    }

    return (
        <Content title={EXHIBITION_TITLE_KEY}>
            <div className={cn(styles.tabsWrapper, isHorizontalMenu() && styles.tabsWrapper_x)}>
                {EXHIBITION_TABS.map((tab) => (
                    <div
                        key={tab}
                        className={cn(styles.tabBtn, activeTab === tab && styles.tabActive)}
                        onClick={() => setActiveTab(tab)}
                    >
                        {translate(tab)}
                    </div>
                ))}
            </div>
            {renderActiveTab()}
        </Content>
    )
}

export const InstancesCatalogExhibition = checkAvailableModule(EXHIBITION_MODULE_KEY)
    ? InstancesCatalogExhibitionComponent
    : null
